import { PeriodNames } from "./maximum-deposit-limit.model";

export const PERIOD_NAMES = {
	1: PeriodNames.Daily,
	7: PeriodNames.Weekly,
	30: PeriodNames.Monthly,
};
